import { DeviceIdentificationType } from '../enums';

export interface IGetAllDevicesParamsDto {
    id?: number[];
    externalId?: string[];
    name?: string[];
    code?: string[];
    from?: string;
    to?: string;
    type?: DeviceIdentificationType;
    values?: string[];
    limit?: number | string;
    page?: number | string;
    sort?: string;
}
